'use client';

import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { BoxContainer, Button } from '@/components';
import type {
  LoanUsesSliceCarouselPrimary,
  Simplify,
} from '../../../../../prismicio-types';

import styles from './loanUsesCarousel.module.scss';
import { LoanUsesCarouselCards } from './LoanUsesCarouselCards/LoanUsesCarouselCards';
import { useVisible } from '@/hooks';

interface LoanUsesCarouselProps {
  data: Simplify<LoanUsesSliceCarouselPrimary>;
}

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

export const LoanUsesCarousel = ({ data }: LoanUsesCarouselProps) => {
  const [isVisible, id] = useVisible();
  const isVisibleStyles = isVisible ? styles.isVisible : '';

  return (
    <BoxContainer styles={styles.container} id={id}>
      <div className={`${styles.title_wrapper} ${isVisibleStyles}`}>
        <PrismicRichText field={data.title} components={components} />
      </div>
      <LoanUsesCarouselCards cards={data.cards} />
      <div className={`${styles.button_wrapper} ${isVisibleStyles}`}>
        <Button
          variation="transparent"
          link={data.button_link}
          text={data.button_text}
          styles={styles.button}
        />
      </div>
    </BoxContainer>
  );
};
